import React, { useState } from 'react';
import {
  StyledButtonWrapper,
  StyledLogoutIcon,
} from '@/components/ui/LogoutButton/LogoutButton.styled.ts';
import LogoutPopUpModal from '@/components/ui/Modals/LogoutModal';

const LogoutButton: React.FunctionComponent = () => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);

  const onCancel = () => {
    setIsConfirmModalOpen(false);
  };

  const onButtonClick = () => {
    setIsConfirmModalOpen(true);
  };
  return (
    <StyledButtonWrapper>
      <StyledLogoutIcon $variant="default" onClick={onButtonClick} />
      <LogoutPopUpModal isOpen={isConfirmModalOpen} onClose={onCancel} />
    </StyledButtonWrapper>
  );
};

export default LogoutButton;
